<script>
  import {csRobotUtil} from '@/da/cs-robot';
  import {csRobotInfo$, loadChatReady$, chatShow$} from '@/streams/cs-robot';
  import {envUtil} from '@/helper';

  let loading = false;

  $: chatShow = $chatShow$;
  $: robotType = getRobotType($csRobotInfo$);
  $: updateChatShow(chatShow);

  function handleClick() {
    if (loading) {
      return;
    }
    loading = true;
    if (chatShow) {
      csRobotUtil.hideChat();
    } else {
      csRobotUtil.openChat();
    }
  }

  function updateChatShow(chatShow) {
    if (loading) {
      loading = false;
    }
  }

  function getRobotType(csRobotInfo) {
    if (!csRobotInfo) {
      return '';
    }
    if (csRobotInfo.name === 'AdaZAW') {
      return 'ada';
    }
    if (csRobotInfo.name === 'PhemexBot') {
      return 'zendesk';
    }
    return '';
  }
</script>

<style>
  .cs-chat {
    position: fixed;
    right: 16px;
    bottom: 16px;
    z-index: 1000000;
    border-radius: 50%;
    width: 64px;
    height: 64px;
    background: #33d43e;
    overflow: hidden;
  }
  .cs-chat img {
    display: block;
    width: 64px;
    height: 64px;
  }
  .icon {
    transition: 0.5s all;
  }
  .show {
    transform: translateY(-64px);
    transition: 0.5s all;
  }
</style>

{#if robotType === 'zendesk' && $loadChatReady$}
  <div id="_cs-chat" class="cs-chat cp" class:dn={(envUtil.isApp || envUtil.isMobile) && chatShow} on:click={handleClick}>
    <div class="icon" class:show={chatShow}>
      <img src='https://img.phemex.com/v1/77b47cea-2144-4b96-9016-8dac310827de/chat.png' alt='Phemex' />
      <img src='https://img.phemex.com/v1/2a90fb75-ffa4-4cb2-9c09-75a88b23aefb/close.png' alt='Phemex' />
    </div>
  </div>
{/if}
